export const gradientFadeStyle = {
  position: "relative",
  maxHeight: "12em",
  overflow: "hidden",
  "&:after": {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    height: "100%",
    width: "100%",
    content: '""',
    pointerEvents: "none",
    background:
      "linear-gradient(rgba(255, 255, 255, 0) 75%, rgb(255, 255, 255) 100%)"
  }
};
